<template>
  <div class="modal__content">
    <div class="image_onboarding_first_document">
      <FirtsImageOnBoarding />
    </div>
    <div class="content_onboarding_employee_first_step">
      <div class="container_onboarding_title">
        <div class="title_onboarding_assistance">
          ¡Bienvenido a tu App MisAbogados!
        </div>
      </div>
      <div class="text_container_onboarding text_first_assistance">
        <div class="">
          Encuentra toda la asistencia legal que necesites en un solo lugar.
          ¡Comencemos!
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FirtsImageOnBoarding from "./assets/firstHome.svg";
import { mapGetters } from "vuex";
export default {
  props: ["size"],
  components: {
    FirtsImageOnBoarding,
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapGetters("Home", {
      stepHomeOnBoarding: "stepHomeOnBoarding",
    }),
  },

  methods: {
    AcceptOnBoarding() {
      let increment = this.stepHomeOnBoarding + 1;

      this.$store.dispatch("Home/counterStepHomeOnBoarding", increment);
    },
    cancelModal() {
      let modal = document.querySelector("#modal__onboarding__home");
      modal.setAttribute("closing", "");
      modal.addEventListener(
        "animationend",
        () => {
          modal.removeAttribute("closing");
          modal.close();
        },
        { once: true }
      );
    },
  },
};
</script>

<style lang="scss">
.text_first_assistance {
  gap: 5rem !important;
  margin-top: 2rem;
}
.title_onboarding_assistance {
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 49px;
  margin-top: 3rem !important;

  @media screen and (max-width: 500px) and (min-width: 200px) {
    font-style: normal;
    font-weight: 700;
    font-size: 26px;
    line-height: 39px;
  }
}
.image_onboarding_first_document {
  width: 339px !important;
  height: 300px !important;
  display: flex;
  margin-top: 5.5rem;
  margin-left: 10.5rem !important;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 500px) and (min-width: 200px) {
    width: 250px !important;
    height: 200px !important;
    margin-left: 2rem !important;
    margin-top: 3rem !important;
  }
}
</style>
